import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import { SAVE_TICKET, TICKET_DETAILS } from "./type";


export const saveTicketDetails = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.fileComplain.createFdTickets}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_TICKET,
            payload: data.response,
        });
        return true;
    }
};

export const fetchTicketDetails = (userId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fileComplain.fetchAllIssue}?user_id=${userId}&is_leadx=true`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TICKET_DETAILS,
            payload: data.response,
        });
        return true;
    }
};